import { render } from "./Success.vue?vue&type=template&id=705bf68e&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=705bf68e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705bf68e"]])

export default __exports__